<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<div *ngIf="no_recfound" class="text-center">
  {{mls?.languageText?.event?.key1}}<span *ngIf="mls?.is_lskey_display==1">(event.key1)</span>
</div>

<span *ngIf="is_res_received && no_recfound==false" (click)="navigateto()" class="cursor-pointer"
  [eventTracker]='{"category":"web_share","action":"click_on_event","product_type":product_type,"product_id":product_type_id}'>
  <div class="bg-white mt-2 p-3 mb-3 rounded cursor-pointer">
    <div class="row">
      <div class="col-md-6">
        <div class="event-img overflow-hidden">
          <img style="height: 250px" class="post-pic w-100" src={{event_detail?.event_banner_list[0]?.file_url}}
            onerror="this.src='assets/img/image_placeholder.svg'" />
        </div>
      </div>
      <div class="col-md-6 fnt-size14px">
        <p class="fnt-size18px fnt-weight500 mb-2 mt-2">{{event_detail?.event_name}}</p>
        <div class="row">
          <!-- time -->
          <div class="col-1" style="min-width: 45px;max-width: 45px;">
            <svg id="Layer_1" data-name="Layer 1" width="20px" viewBox="0 0 14 14">
              <defs>
                <style>
                  .event-tim-1 {
                    fill: #9e9e9f;
                  }
                </style>
              </defs>
              <path class="event-tim-1"
                d="M7,1a6,6,0,1,0,6,6A6,6,0,0,0,7,1ZM9.73,8.07H6.84a.75.75,0,0,1-.75-.75V3.22a.75.75,0,0,1,1.5,0V6.57H9.73a.75.75,0,0,1,0,1.5Z" />
            </svg>
          </div>
          <div class="col-11 pl-0" style="max-width: 80%;">
            <p class="fnt-weight500 mb-2">{{event_detail?.start_date |date  :'d MMM h:mm a'}} -
              {{event_detail?.end_date | date  :'d MMM h:mm a'}}</p>
          </div>
          <div class="col-12"></div>
          <!-- address -->
          <div class="col-1" style="min-width: 45px;max-width: 45px;">
            <svg id="Layer_1" data-name="Layer 1" width="20px" viewBox="0 0 14 14">
              <defs>
                <style>
                  .event-loc-1 {
                    fill: #9e9e9f;
                  }
                </style>
              </defs>
              <path class="event-loc-1"
                d="M7,.68a4.8,4.8,0,0,0-4.8,4.8c0,3.79,4,7.84,4.8,7.84.25,0,4.8-3.54,4.8-7.84A4.8,4.8,0,0,0,7,.68ZM7,7.25A2.27,2.27,0,1,1,9.27,5,2.27,2.27,0,0,1,7,7.25Z" />
            </svg></div>
          <div class="col-11 pl-0" style="max-width: 80%;">
            <p class="fnt-weight500 mb-2">{{event_detail?.location}}</p>
            <!-- <p class="text-medium-grey mb-2">Shahpur Jat</p> -->
          </div>
          <div class="col-12"></div>
          <!-- days -->
          <div class="col-1" style="min-width: 45px;max-width: 45px;">
            <svg id="Layer_1" data-name="Layer 1" width="20px" viewBox="0 0 14 14">
              <defs>
                <style>
                  .event-days-1 {
                    fill: #9e9e9f;
                  }
                </style>
              </defs>
              <path class="event-days-1"
                d="M11,2.09H9.91V1H9.18V2.09H4.82V1H4.09V2.09H3A1.45,1.45,0,0,0,1.55,3.55v8A1.45,1.45,0,0,0,3,13h8a1.45,1.45,0,0,0,1.45-1.45v-8A1.45,1.45,0,0,0,11,2.09Zm-.24,8H3.24V6.25h7.52Z" />
            </svg>
          </div>
          <div class="col-11 pl-0" style="max-width: 80%;">
            <p class="fnt-weight500 mb-2">{{event_detail?.number_days}} {{mls?.languageText?.event?.key2}}<span
                *ngIf="mls?.is_lskey_display==1">(event.key2)</span></p>
          </div>
          <div class="col-12"></div>
          <!-- by -->
          <div class="col-1" style="min-width: 45px;max-width: 45px;">
            <svg id="Layer_1" data-name="Layer 1" width="15px" viewBox="0 0 14 14">
              <defs>
                <style>
                  .event-speak-1 {
                    fill: #9e9e9f;
                  }
                </style>
              </defs>
              <circle class="event-speak-1" cx="7" cy="3.75" r="3.25" />
              <path class="event-speak-1"
                d="M9,7.72H5A4.47,4.47,0,0,0,.5,12.19V13.5h13V12.19A4.47,4.47,0,0,0,9,7.72Z" />
            </svg>
          </div>
          <div class="col-11 pl-0" style="max-width: 80%;">
            <p class="fnt-weight500">{{event_detail?.hosted_by}}</p>
          </div>
        </div>

        <div class="pt-3 border-top mt-2">
          <div class="row">
            <div class="col-4">
              <p class="text-center"><span class="cursor-pointer"><svg viewBox="0 0 16 16" width="20px">
                    <defs>
                      <style>
                        .shre-card {
                          fill: var(--medium-grey);
                        }
                      </style>
                    </defs>
                    <g data-name="Layer 3" id="Layer_3">
                      <path class="shre-card" d="M9.5,13.2V9.92C5.33,9.92,2.58,11.2.5,14c.84-4,3.16-8,9-8.8V2l6,5.59Z">
                      </path>
                    </g>
                  </svg> {{mls?.languageText?.event?.key3}}<span
                    *ngIf="mls?.is_lskey_display==1">(event.key3)</span></span></p>
            </div>
            <div class="col-8">
              <button class="btn text-white btn-success fnt-size14px w-100">

                <svg id="Layer_1" data-name="Layer 1" width="15px" viewBox="0 0 16 16">
                  <defs>
                    <style>
                      .event-tick-1 {
                        fill: none;
                        stroke: #fff;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 2px;
                      }
                    </style>
                  </defs>
                  <polyline class="event-tick-1" points="14.72 3.64 5.99 12.36 1.28 8.05" />
                </svg> {{mls?.languageText?.event?.key4}}<span *ngIf="mls?.is_lskey_display==1">(event.key4)</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-2 bg-white rounded fnt-size14px" *ngIf=" doctalkDetail?.channel?.pharma_classification!='pharma' ">
    <div class="p-3">
      <p class="mb-2 fnt-weight500"> {{mls?.languageText?.event?.key5}}<span
          *ngIf="mls?.is_lskey_display==1">(event.key5)</span></p>
      <div class="row m-0" style="margin-left: -0.5rem !important; margin-right: -0.5rem !important;">

        <div class="col-md-6 pr-2 pl-2" *ngFor="let eventSession of event_detail?.event_days_list; let idx=index">
          <div class="border p-2 rounded cursor-pointer mb-3 position-relative">
            <p class="fnt-size14px">{{eventSession?.program_name}}
              <span class="d-block text-medium-grey fnt-size12px">
                {{eventSession?.total_session}} {{mls?.languageText?.event?.key5}}<span
                  *ngIf="mls?.is_lskey_display==1">(event.key5)</span>
              </span>
            </p>
            <svg class="position-absolute" style="right: 7px;top: 20px;" viewBox="0 0 15 15" width="15px">
              <defs>
                <style>
                  .right-arrow-events-1 {
                    fill: none;
                    stroke: #9e9d9e;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 1.5px;
                  }
                </style>
              </defs>
              <g data-name="Layer 3" id="Layer_3">
                <polyline class="right-arrow-events-1" points="5 2.5 10 7.5 5 12.5"></polyline>
              </g>
            </svg>
          </div>
        </div>


      </div>
    </div>
    <div class="border-top p-3">
      <p class="mb-2 fnt-weight500"> {{mls?.languageText?.event?.key6}}<span
          *ngIf="mls?.is_lskey_display==1">(event.key6)</span></p>
      <p>{{event_detail?.event_description}}</p>
      <div class="mt-3 pt-3 border-top">
        <div class="row" *ngIf="event_detail?.total_media > 0">
          <div class="col-6">
            <p class="mb-2 fnt-weight500"> {{mls?.languageText?.event?.key7}}<span
                *ngIf="mls?.is_lskey_display==1">(event.key7)</span></p>
          </div>
          <div class="col-6">
            <p class="text-medium-grey fnt-size12px text-right">{{event_detail?.total_media}}</p>
          </div>
        </div>


        <div class="row m-0" style="margin-left: -0.5rem !important; margin-right: -0.5rem !important;">
          <div class="col-md-6 pr-2 pl-2" *ngFor="let eventSession of event_detail?.event_days_list; let idx=index">
            <div class="border p-2 rounded cursor-pointer mb-3 position-relative">
              <p class="text-success"> {{eventSession?.program_name}}</p>
              <svg class="position-absolute" style="right: 7px;top: 10px;" viewBox="0 0 15 15" width="15px">
                <defs>
                  <style>
                    .right-arrow-events-1 {
                      fill: none;
                      stroke: #9e9d9e;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                      stroke-width: 1.5px;
                    }
                  </style>
                </defs>
                <g data-name="Layer 3" id="Layer_3">
                  <polyline class="right-arrow-events-1" points="5 2.5 10 7.5 5 12.5"></polyline>
                </g>
              </svg>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>



  <div *ngIf="clinicalDetailData?.channel?.pharma_classification=='pharma'">
    <h3 class=" text-center mt-4"> {{mls?.languageText?.event?.key8}}<span
        *ngIf="mls?.is_lskey_display==1">(event.key8)</span></h3>
  </div>



</span>